/**
 * We can't use DecimalRenderer to display currency conversion rates values, because for small numbers like 1.17e-7 numeral.js returns null.
 * That's why we use custom cell renderer for those values.
 */
const redundantDecimalsRegex = /\.?0+$/;

const isNumberLike = value => (typeof value === 'string' || typeof value === 'number') && !isNaN(value);

const CurrencyRateCellRenderer = ({ value }) => isNumberLike(value)
  ? Number(value).toFixed(10).replace(redundantDecimalsRegex, '')
  : value;

export default CurrencyRateCellRenderer;
